import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getTiles} from '../../../actions/home';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import IgniteDataTable from '../../common/datatable'
import TileLocation from './tile-location'
import {history} from "../../../store";

class Tiles extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.dispatch(getTiles());
    }

    render() {
        const columns = [
            
            {
                prop: 'links.image',
                title: 'Tile Location',
                format(data, row) {
                    if(row.id !== null)    
                    return <TileLocation filled={row.id}/>
                }
            }, {
                prop: 'button-label',
                title: 'Button Label'
            }
        ];
        
        const actions = [];
        if (this.props.fetched) {
            
            actions.push({
                label: 'Edit',
                permissions: {
                    action:       'handle',
                    subjectClass: 'home_page'
                },
                callback: (row) => {
                    history.push(row.attributes.kind === 'dynamic' ? `/admin/dynamic-edit-tile/${row.id}` : `/admin/edit-tile/${row.id}`);
                }
            })
        }
        
        if (this.props.fetched) {
            return (
                <div className="Carouselslist">
                    <IgniteDataTable
                        data={this.props.tiles}
                        hasAttributes={true}
                        columns={columns}
                        actions={actions}
                        pagination={false}/>
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    }
}

Tiles.propTypes = {};

const mapStateToProps = (state) => {
    return {tiles: state.home.home_tiles, fetching: state.home.fetching, fetched: state.home.fetched};
}

export default connect(mapStateToProps)(Tiles);


// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/tiles.jsx